import type { AiResultData } from "./types";

function sortedInsert(
  list: readonly AiResultData[],
  item: AiResultData,
): AiResultData[] {
  const at = list.findIndex((r) => r.relevance < item.relevance);
  const next = [...list];
  if (at === -1) {
    next.push(item);
  } else {
    next.splice(at, 0, item);
  }
  return next;
}

/**
 * Places an excerpt in relevance order, descending.
 *
 * Excerpts arrive one at a time and out of order, so a late arrival can land at
 * the top. Ids can repeat: the server looks a page up per streamed element, so
 * a model that names the same id twice produces two excerpts. The higher
 * relevance wins.
 *
 * Returns `list` itself when nothing changed, because array identity is how
 * consumers detect that results moved.
 */
export function insertResult(
  list: readonly AiResultData[],
  incoming: AiResultData,
): AiResultData[] {
  const existingAt = list.findIndex((r) => r.id === incoming.id);

  if (existingAt === -1) {
    return sortedInsert(list, incoming);
  }

  if (list[existingAt].relevance >= incoming.relevance) {
    return list as AiResultData[];
  }

  const without = list.filter((_, i) => i !== existingAt);
  return sortedInsert(without, incoming);
}
